import { colors } from '@src/styles';

export const titleFontFamily = "'Inter Tight', 'Inter', sans-serif";
export const monoFontFamily = "'JetBrains Mono', monospace";

export const monoLabelSX = {
  fontFamily: monoFontFamily,
  fontSize: '10px',
  letterSpacing: '0.16em',
  textTransform: 'uppercase',
  color: colors.brand.textMuted,
} as const;

export const searchFieldSX = {
  '& .MuiOutlinedInput-root': {
    height: 36,
    fontSize: '13px',
    backgroundColor: colors.brand.surface,
    borderRadius: '8px',
    color: colors.primary.white,
    '& fieldset': { borderColor: colors.brand.line },
    '&:hover fieldset': { borderColor: colors.primary.yellow },
    '&.Mui-focused fieldset': { borderColor: colors.primary.yellow },
  },
  '& input::placeholder': { color: colors.brand.textMuted, opacity: 1 },
} as const;

export const sectionCardSX = {
  backgroundColor: colors.brand.surface,
  border: `1px solid ${colors.brand.line}`,
  borderRadius: '12px',
} as const;

export const tonePillSX = (color: string) =>
  ({
    display: 'inline-flex',
    alignItems: 'center',
    height: 20,
    paddingX: 1,
    borderRadius: '999px',
    border: `1px solid ${color}55`,
    backgroundColor: `${color}14`,
    color,
    fontFamily: monoFontFamily,
    fontSize: '9.5px',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  }) as const;

export const formatCanonicalDate = (value?: string): string =>
  value
    ? new Date(value).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '—';
